export default {
  "content": "<title>Chevron Forward</title><path d=\"M184 112l144 144-144 144\" class=\"ionicon-fill-none\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};